import type { Theme } from '@mui/material/styles';
import { accentHues, fonts } from '@/shared/theme';

/** Series palette of the prototype (location dots, chart lines). */
export const seriesPalette = [
  accentHues.green,
  accentHues.blue,
  accentHues.violet,
  accentHues.amber,
  accentHues.rose,
  accentHues.emerald,
  '#0EA5E9',
  '#A855F7',
  '#64748B',
] as const;

export const seriesColor = (index: number) =>
  seriesPalette[index % seriesPalette.length] ?? accentHues.green;

// MUI X class names as plain strings: importing the `*Classes` objects would pull the whole
// charts package into the app shell, which only needs it on chart screens.
const axis = (slot: string) => `.MuiChartsAxis-${slot}`;

/** Prototype chart look for MUI X charts: dashed grid, faint tick labels, strong baseline. */
export const chartSx = (theme: Theme) => ({
  '& .MuiChartsGrid-line': {
    stroke: theme.vars.palette.md.border,
    strokeDasharray: '2 6',
  },
  [`& ${axis('tickLabel')}`]: {
    fill: `${theme.vars.palette.md.faint} !important`,
    fontFamily: fonts.body,
    fontSize: '11px !important',
    fontVariantNumeric: 'tabular-nums',
  },
  [`& ${axis('directionX')} ${axis('tickLabel')}`]: {
    fill: `${theme.vars.palette.md.muted} !important`,
    fontWeight: 600,
    fontSize: '12px !important',
  },
  [`& ${axis('line')}`]: { stroke: theme.vars.palette.md.borderStrong },
  [`& ${axis('directionY')} ${axis('line')}`]: { display: 'none' },
  [`& ${axis('tick')}`]: { display: 'none' },
  '& .MuiChartsLegend-label': {
    fontFamily: fonts.body,
    fontSize: 12,
    fontWeight: 600,
    color: theme.vars.palette.md.muted,
  },
  '& .MuiLineChart-area': { fillOpacity: 0.14 },
  '& .MuiLineChart-line': { strokeWidth: 2.2 },
});
